module.exports = __webpack_public_path__ + "img/index_foot.74dd505f.png";